import React, { lazy } from 'react';

const ProjectJournalListing = lazy(() =>
  import('./ProjectJournalListing').then(module => ({
    default: module.ProjectJournalListing,
  })),
);

const ProjectJournalForm = lazy(() =>
  import('./ProjectJournalForm').then(module => ({
    default: module.ProjectJournalForm,
  })),
);

const ProjectJournalItemForm = lazy(() =>
  import('./components/ProjectJournalItemForm').then(module => ({
    default: module.ProjectJournalItemForm,
  })),
);

const ProjectJournalDetail = lazy(() =>
  import('./ProjectJournalDetail').then(module => ({
    default: module.ProjectJournalDetail,
  })),
);

const projectJournalRoutes = [
  {
    props: {
      exact: true,
      path: '/project-accounting/project-journal',
    },
    component: <ProjectJournalListing />,
  },
  {
    props: {
      exact: true,
      path: '/project-accounting/project-journal/detail/:costAdjustmentID',
    },
    component: <ProjectJournalDetail />,
  },
  {
    props: {
      exact: true,
      path: '/project-accounting/project-journal/new',
    },
    component: <ProjectJournalForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path:
        '/project-accounting/project-journal/approve-reject/:costAdjustmentID',
    },
    component: <ProjectJournalForm mode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path: '/project-accounting/project-journal/:formMode/:costAdjustmentID',
    },
    component: <ProjectJournalForm mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/project-accounting/project-journal/:formMode/item/add',
    },
    component: <ProjectJournalItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path:
        '/project-accounting/project-journal/:formMode/item/:itemMode/:itemID',
    },
    component: <ProjectJournalItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path:
        '/project-accounting/project-journal/:formMode/:costAdjustmentID/item/add',
    },
    component: <ProjectJournalItemForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/project-accounting/project-journal/:formMode/:costAdjustmentID/item/:itemMode/:itemID',
    },
    component: <ProjectJournalItemForm mode="new" />,
  },
];

export default projectJournalRoutes;
